import DashboardLayout from "../../layouts/DashboardLayout";
import "./AboutSoftware.css";

export default function AboutSoftware() {
  return (
    <DashboardLayout>
      <div className="about-container">
        <div className="about-card">
          <div className="about-header">
            <h1>NN FIT Software</h1>

            <span className="version-badge">Version 1.0</span>

            <p>
              Smart Gym Management Platform designed to simplify member
              management, attendance, subscriptions, payments and reporting.
            </p>
          </div>
          <div className="about-section">
            <h2> About Gym Software</h2>

            <p>
              Gym Software is a complete cloud-based Gym Management Software
              designed to simplify daily gym operations. It helps gym owners
              manage members, trainers, attendance, subscriptions, payments,
              reports, and business growth from a single dashboard.
            </p>
          </div>

          <div className="about-section">
            <h2> Core Features</h2>

            <ul>
              <li>Member Management</li>
              <li>Trainer Management</li>
              <li>Attendance Tracking</li>
              <li>Diet Plans</li>
              <li>Workout Plans</li>
              <li>QR Code Attendance System</li>
              <li>Payment Management</li>
              <li>Membership Plans</li>
              <li>Revenue Analytics</li>
              <li>Subscription Management</li>
              <li>Expiry Alerts</li>
              <li>Reports & Dashboard Analytics</li>
              <li>Role-Based Access Control</li>
              <li>Cloud Data Storage</li>
            </ul>
          </div>

          <div className="about-section">
            <h2> Benefits For Gym Owners</h2>

            <ul>
              <li>Reduce manual paperwork</li>
              <li>Track member attendance instantly</li>
              <li>Monitor revenue and payments</li>
              <li>Get subscription expiry alerts</li>
              <li>Manage multiple trainers efficiently</li>
              <li>Access data anytime, anywhere</li>
              <li>Improve member experience</li>
            </ul>
          </div>

          <div className="about-section">
            <h2> Upcoming Features</h2>

            <ul>
              <li>Mobile App (Android & iOS)</li>
              <li>WhatsApp Notifications</li>
              <li>SMS Reminders</li>
              <li>Online Membership Renewal</li>
              <li>Diet & Workout Tracking</li>
              <li>AI-Powered Business Insights</li>
              <li>Multi-Branch Gym Management</li>
            </ul>
          </div>

          <div className="about-section">
            <h2> Security & Reliability</h2>

            <ul>
              <li>Secure Authentication</li>
              <li>Cloud Database Backup</li>
              <li>Role-Based Access</li>
              <li>Encrypted Data Storage</li>
              <li>Regular Software Updates</li>
            </ul>
          </div>

          <div className="about-section">
            <h2> Technical Support</h2>

            <p>
              Our support team is available to assist with software setup,
              customization, troubleshooting, and training.
            </p>

            <div className="contact-grid">
              <div>
                <strong>Phone</strong>
                <p>8688663447</p>
              </div>

              <div>
                <strong>Email</strong>
                <p>info@nnaisolution.com</p>
              </div>

              <div>
                <strong>Location</strong>
                <p>Nizamabad, Telangana</p>
              </div>

              <div>
                <strong>Support Hours</strong>
                <p>Mon - Sat | 9 AM - 7 PM</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2> Getting Started</h2>

            <ol>
              <li>Complete Gym Registration</li>
              <li>Get Approval From Super Admin</li>
              <li>Choose Subscription Plan</li>
              <li>Configure Gym Settings</li>
              <li>Add Trainers</li>
              <li>Add Members</li>
              <li>Track Attendance</li>
              <li>Manage Payments & Reports</li>
            </ol>
          </div>

          <div className="about-section">
            <h2> Developed By</h2>

            <p>NN AI Solutions</p>

            <p>
              AI, Software Development, Digital Marketing & Business Automation
              Solutions.
            </p>
          </div>

          <div className="about-footer">
            © 2026 NN FIT. All Rights Reserved.
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
